import { executeRequest, Request } from '@jfs/network'
import { getEncryptedPwdAndKey } from '@jfs/utils'
import {
  getEncryptedAuthCodeAndCodeVerifier,
  getNetworkResponseError,
  isStatusOK,
  isStatusSuccess,
  pkceCodeChallenge,
} from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApi } from './sendEvent'

const responseParser = (data: any, token, request) => {
  if (isStatusOK(data) && isStatusSuccess(data?.data)) {
    sendEventApi(token, request, { status: 'SUCCESS' })
    return {
      authorizationCode: data?.data?.authorizationCode,
      appAccessToken: data?.data?.session?.accessToken?.tokenValue,
      appRefreshToken: data?.data?.session?.refreshToken?.tokenValue,
      appAccessTokenExpiry: data?.data?.session?.accessToken?.expiresIn,
      appRefreshTokenExpiry: data?.data?.session?.refreshToken?.expiresIn,
      appIdToken: data?.data?.session?.appIdentifierToken,
    }
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const appAuthenticateVerify = (authCode: string, codeVerifier: string, CLIENT_ID: string, token: any) => {
  const { REACT_APP_JFS_PUBLIC_KEY = '' } = process.env
  const encryptedObj = getEncryptedAuthCodeAndCodeVerifier(authCode, codeVerifier, REACT_APP_JFS_PUBLIC_KEY)
  const request: Request<{}> = {
    apiPath: APIEndPoints.appAuth,
    method: 'POST',
    config: apiConfig(token),
    body: getAppAuthticateVerifyRequest(CLIENT_ID, encryptedObj),
  }
  sendEventApi(token, request, { status: 'INITIATED' })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data, token, request)
    })
    .catch((err) => {
      sendEventApi(token, request, { status: 'FAILED', errorDescription: err?.data })
      throw getNetworkResponseError(err?.data)
    })
}

const getAppAuthticateVerifyRequest = (CLIENT_ID: any, encryptedObj: any) => {
  return {
    application: {
      clientId: CLIENT_ID,
    },
    authenticateList: [
      {
        mode: 24,
        action: 'VERIFY',
        authorizationCode: encryptedObj.authCodeEnc,
        value: encryptedObj.codeVerifierEnc,
      },
    ],
    purpose: 2,
    scope: 'SESSION',
    secure: {
      encryptionKey: encryptedObj.key,
    },
  }
}

export const appAuthenticateGenerate = (codeVerifier: string, CLIENT_ID: string, token: any) => {
  const { REACT_APP_JFS_PUBLIC_KEY = '' } = process.env
  const challenge = pkceCodeChallenge(codeVerifier)
  const encCodeChallenge = getEncryptedPwdAndKey(challenge.toString(), REACT_APP_JFS_PUBLIC_KEY)
  const request: Request<{}> = {
    apiPath: APIEndPoints.appAuth,
    method: 'POST',
    body: {
      application: {
        clientId: CLIENT_ID,
      },
      authenticateList: [
        {
          mode: 24,
          action: 'GENERATE',
          value: encCodeChallenge.password,
        },
      ],
      purpose: 2,
      extraInfo: 'Test Info',
      scope: 'REQUEST',
      secure: {
        encryptionKey: encCodeChallenge.key,
        method: 'SHA-256',
      },
    },
    config: apiConfig(token),
  }
  sendEventApi(token, request, { status: 'INITIATED' })

  return executeRequest(request)
    .then((data) => {
      return responseParser(data, token, request)
    })
    .catch((error) => {
      sendEventApi(token, request, { status: 'FAILED', errorDescription: error?.data })
      throw error
    })
}
